<div class="breadcrumbs" [class]="{noBack: !back}">
  <fa-icon class="arrow" icon="arrow-left" (click)="return()" *ngIf="back"></fa-icon>
  <ul>
    <ng-container *ngFor="let crumb of crumbs">
      <li><span class="pointer" [routerLink]="[crumb.address]">{{crumb.name | uppercase}}</span></li>
    </ng-container>
  </ul>
  <ng-container *ngIf="!sending; else spinner">
    <div class="botones" style="display:flex; align-items: center;">
      <div class="box-email-icon flex justify-content-between align-items-center mx-1" (click)="openMail()">
        <div class="bg-email d-flex justify-content-center align-items-center">
          <img class="email-icon" src="./assets/img/icon-email.svg" alt="">
        </div>
      </div>

      <fa-icon icon="question-circle"
      class="flex justify-content-between align-items-center help mx-1"
      (click)="openHelp()"></fa-icon>

    </div>
  </ng-container>
</div>

<ng-template #spinner>
  <fa-icon class="mainColorText" icon="spinner" [spin]="true"></fa-icon>
</ng-template>
